var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"preloader"}},[_c('div',{attrs:{"id":"status"}},[_c('div',{staticClass:"spinner"},[_c('i',{staticClass:"ri-loader-line spin-icon"})])])])
}]

export { render, staticRenderFns }